import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"

const SimpleImage = styled.img`
  margin: 0 auto;
  max-width: 100%;
`
/**
 *
 * @param {string} classes
 * @param {string} alt
 * @param {string} role
 * @param {string} filename
 * @returns {Element}
 * @constructor
 */
const Image = ({ classes = "", alt = "", role, filename }) => {
  //check if filename is a http/CDN link
  if (filename?.startsWith("http")) {
    return (
      <SimpleImage
        src={filename}
        className={classes + " SimpleImage"}
        alt={alt}
        role={alt !== "" ? undefined : "presentation"}
      />
    )
  }

  //otherwise looking in repo
  return (
    /* eslint-disable */
    <StaticQuery
      query={graphql`
        query {
          images: allFile {
            edges {
              node {
                relativePath
                name
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      `}
      /* eslint-enable */
      render={(data) => {
        /*
         * console.log(props.filename)
         * console.log(props.alt)
         */
        const image = data.images.edges.find((n) => {
          return n.node.relativePath === filename
        })
        if (!image) {
          console.warn(`image error` + filename)
          return null
        }

        return (
          <GatsbyImage
            image={getImage(image.node)}
            alt={alt}
            role={role || null}
            className={classes}
          />
        )
      }}
    />
  )
}

export default Image
